import styled from "styled-components";
import { device } from "../../../../../../device";

export const Line = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  justify-content: center;
`;

export const FormGroup = styled.div`
  padding: 0 5px;
  margin-bottom: 10px;
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
`;

export const LeftText = styled.label`
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  position: relative;
  padding: calc(0.375rem + 1px) 15px;
  width: 100%;
  @media ${device.tablet}{
    flex: 0 0 30%;
    max-width: 30%;
    text-align: right;
  }
  @media not ${device.tablet}{
    flex: 0 0 100%;
    max-width: 100%;
    text-align: left;
  }
`;

export const RightText = styled.label`
  font-size: 10pt;
  align-self: center !important;
  display: block;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  position: relative;
  padding: 0.375rem 15px 0.375rem 15px;
  text-align: right;
  border 1px solid #000;
  width: 100%;
  @media ${device.tablet}{
    flex: 0 0 30%;
    max-width: 30%;
  }
  @media not ${device.tablet}{
    flex: 0 0 100%;
    max-width: 100%;
  }
`;
